// extracted by mini-css-extract-plugin
export default {"wrapper":"CreatePostPage_wrapper__+kcp-","create-post-btn":"CreatePostPage_create-post-btn__2IszD"};